<template>
  <span class="mt-badge" :class="badgeClass">
    <slot />
  </span>
</template>

<script setup>
const props = defineProps({
  color: {
    type: String,
    default: "blue", // blue, green, red, yellow, gray
  }
});

const badgeClass = {
  blue: "mt-badge-blue",
  green: "mt-badge-green",
  red: "mt-badge-red",
  yellow: "mt-badge-yellow",
  gray: "mt-badge-gray",
  orange: "mt-badge-orange",
  purple: "mt-badge-purple",
}[props.color];
</script>
